import { Facebook, Instagram, Linkedin } from "lucide-react";
import React, { useState } from "react";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Brand } from "@/components/common/Brand";
import { LanguageSwitcher } from "@/components/common/LanguageSwitcher";
export function Footer() {
  const { t } = useTranslation();
  const columns = [];
  return (
    <footer className="bg-navy-950 text-white">
      <div className="container-shell py-14 lg:py-18">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5">
          <div className="sm:col-span-3">
            <Brand light />
            <p className="mt-5 max-w-md text-sm leading-7 text-slate-400">
              {t("footer.description")}
            </p>
            {/* <div className="mt-6 flex gap-3">
              {[Linkedin, Instagram, Facebook].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="flex size-10 items-center justify-center rounded-xl border border-white/10 text-slate-300 transition hover:border-gold-400 hover:text-gold-400"
                  aria-label={`${t("footer.social")} ${index + 1}`}
                >
                  <Icon className="size-4" />
                </a>
              ))}
            </div> */}
          </div>
          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-bold text-white">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map(([label, to]) => (
                  <li key={label}>
                    <Link
                      to={to}
                      className="text-sm text-slate-400 transition hover:text-white"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-6 flex flex-col gap-4 border-t border-white/10 pt-7 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p>
              {t("footer.copyright", {
                year: new Date().getFullYear(),
              })}
            </p>
            <p className="mt-1">{t("footer.disclaimer")}</p>
          </div>
          {/* <LanguageSwitcher dark /> */}
        </div>
      </div>
    </footer>
  );
}
